/**
 * Created by Ning Jiang on 2021-09-23.
 */

import {Emitter} from "pixi-particles";
import {TombstoneRip} from "../TombstoneRip";
import {ParticlesManager} from "../../core/particles/ParticlesManager";

export class WinCapParticles extends PIXI.Container {

    private _particlesConfig:any = {
        "alpha": {
            "start": 0.76,
            "end": 0.4
        },
        "scale": {
            "start": 1.0,
            "end": 0.4,
            "minimumScaleMultiplier": 2
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 5,
            "end": 10,
            "minimumSpeedMultiplier": 2
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 0,
            "max": 360
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 50,
            "max" : 100
        },
        "lifetime" : {
            "min" : 20,
            "max" : 30
        },
        "blendMode" : "normal",
        "frequency" : 0.5,
        "emitterLifetime" : -1,
        "maxParticles" : 200,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -300,
            "y" : -250,
            "w" : 600,
            "h" : 500
        }
    };
    private _emitter:Emitter;

    private _isPlaying:boolean = false;

    constructor() {
        super();
    }

    public play():void {
        this._isPlaying = true;

        if(!this._emitter) {
            this._emitter = new Emitter(this, [
                TombstoneRip.assetLoader.getTextures("wincap/spark_1")[0],
                // TombstoneRip.assetLoader.getTextures("wincap/spark_2")[0]
                TombstoneRip.assetLoader.getTextures("wincap/spark_3")[0]
                // TombstoneRip.assetLoader.getTextures("wincap/spark_4")[0]
            ], this._particlesConfig);
        }
        ParticlesManager.addEmitter(this._emitter);
    }

    public stop():void {
        if(this._emitter) {
            ParticlesManager.removeEmitter(this._emitter);
        }
    }
}